<template>
  <el-dialog :style="{ '--el-dialog-padding-primary': 0 }" @close="close" class="detail-radonly-dialog" v-model="visible" :width="width" append-to-body close-on-click-modal close-on-press-escape :show-close="false">
    <template #header>
      <div class="dialog-header">
        <span class="dialog-title">{{ control.name || '明细列表' }}</span>
        <span class="dialog-close" @click="visible = false">
           <el-icon>
             <Close />
           </el-icon>
        </span>
      </div>
    </template>
    <div class="detail-readonly">
      <template v-if="openType === 'details'">
        <detailsTable @signetdetail="signetdetailFun" :pageSize="pageSize" v-if="visible" :current="currentPage" :formdata="formdata" :detailsWidgetData="control" :curkey="control.isCutDataConfig && control.cutDataConfig.length > 0 ? pageSize : ''" />
        <el-pagination style="margin-top: 10px;" v-if="control.pagination && formdata.length > 20" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="formdata.length"/>
      </template>
      <template v-else>
        <div style="min-height: 320px;" class="textarea-content">
          <el-input style="height: 270px;" type="textarea" v-model="textareaValue" :placeholder="control.placeholder || '请输入内容'"></el-input>
          <div style="height: 50px;" class="textarea-body">
            <el-button type="primary" @click="confirm">确定</el-button>
            <el-button @click="visible = false">取消</el-button>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import detailsTable from "@/components/clientSide/formFillinPageChild/detailsTable/detailsTable.vue"; // 引入详情表格组件
import { filePreview } from '@/api/global.js'
export default {
  name: 'DetailReadonly',
  props: {
    width: {
      type: String,
      default: '50%'
    }
  },
  components: {
    detailsTable
  },
  data() {
    return {
      // 这里可以添加组件的数据属性
      visible: false,
      formdata: [],
      control: {},
      pageSize: 20,
      currentPage: 1,
      openType: 'details',
      textareaValue: '',
      oldValue: '',
      row: {}
    }
  },
  methods: {
    // 这里可以添加组件的方法
    open(opt = {}, type = 'details') {
      this.openType = type
      for (const key in opt) {
        this[key] = opt[key]
      }
      if (type === 'textarea') {
        this.oldValue = this.row[this.control.title]
      }
      this.visible = true
    },
    close() {
      const initialData = this.$options.data.call(this)
      Object.assign(this.$data, initialData)
      this.visible = false
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    signetdetailFun(command, list) {
      //明细的数据操作
      if (list === 1) {
        // TODO
      } else if (list === 2) {
        // TODO
      } else if (list === 3) {
        //下载
        filePreview(command, true);
      } else if (list === 4) {
        //预览
        filePreview(command)
      } else {
        // TODO
      }
    },
    confirm() {
      if (this.textareaValue === this.oldValue) { 
        this.visible = false
      } else {
        this.$emit('confirm', { column: this.control, value: this.textareaValue, row: this.row })
        this.visible = false
      }
    },
  }
}
</script>

<style lang="scss">
.detail-radonly-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.dialog-header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #e4e7ed;
  background-color: #F2F2F2;
	border-top-left-radius: 2px;
	border-top-right-radius: 2px;
  .dialog-title {
    font-size: 18px;
    font-weight: 500;
  }
  .dialog-close {
    float: right;
    cursor: pointer;
  }
}
.detail-readonly {
  padding: 20px;
}

.textarea-content {
  ::v-deep .el-textarea {
    .el-textarea__inner {
      height: 270px;
    }
  }
  .textarea-body {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
}
</style>